import constants from "./constants";

const localStorageKeys = constants.LOCAL_STORAGE.KEYS;

export const setSession = (
  userId: number,
  email: string,
  accessToken: string,
  companyId: number
) => {
  localStorage.setItem(localStorageKeys.USER_ID, String(userId));
  localStorage.setItem(localStorageKeys.USER_EMAIL, email);
  localStorage.setItem(localStorageKeys.ACCESS_TOKEN, accessToken);
  localStorage.setItem(localStorageKeys.COMPANY_ID, String(companyId));
};

export const clearSession = () => {
  for (const key in localStorage) {
    if (
      key.includes("rudder" || "debug" || "bugsnag") ||
      Object.values(localStorageKeys).includes(key)
    )
      localStorage.removeItem(key);
  }
};

export const getAccessToken = (): string | null => {
  return localStorage.getItem(localStorageKeys.ACCESS_TOKEN) || null;
};

export const setUserFullName = (fullName: string) => {
  localStorage.setItem(localStorageKeys.FULL_NAME, fullName);
};

export const getUserFullName = (): string | null => {
  return localStorage.getItem(localStorageKeys.FULL_NAME) || null;
};

export const setLastCheckEmail = (email: string) => {
  localStorage.setItem(localStorageKeys.LAST_CHECKED_EMAIL, email);
};

export const clearLastCheckedEmail = () => {
  localStorage.removeItem(localStorageKeys.LAST_CHECKED_EMAIL);
};

export const getLastCheckEmail = (): string | null => {
  return localStorage.getItem(localStorageKeys.LAST_CHECKED_EMAIL) || null;
};

export const setEmailFromLanding = (email: string) => {
  localStorage.setItem(localStorageKeys.EMAIL_FROM_LANDING, email);
};

export const clearEmailFromLanding = () => {
  localStorage.removeItem(localStorageKeys.EMAIL_FROM_LANDING);
};

export const getEmailFromLanding = (): string | null => {
  return localStorage.getItem(localStorageKeys.EMAIL_FROM_LANDING) || null;
};

export const getBrowserNavigatorLanguage = () => {
  let language = navigator.language.toLowerCase().split(/[_-]+/)[0] || "en";
  localStorage.setItem(localStorageKeys.LOCALE, language);

  return language;
};
